module.exports = __webpack_public_path__ + "img/icon-drop_greje.png";